/* eslint-disable @typescript-eslint/no-explicit-any */
import { GridColDef } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";

import { Button } from "@mui/material";
import { JunkValue } from "./types";

const getColumns = ({
  onDelete,
}: {
  onDelete: (row: JunkValue) => void;
}): GridColDef[] => [
  {
    field: "id",
    headerName: "ID",
  },
  {
    field: "value",
    headerName: "Value",
    flex: 1,
  },
  {
    field: "actions",
    type: "actions",
    headerName: "Actions",

    align: "right",
    getActions: ({ row }: { row: JunkValue }) => [
      <Button
        key="delete"
        onClick={(e: any) => {
          e.stopPropagation();
          onDelete(row);
        }}
      >
        <DeleteIcon fontSize="small" />
      </Button>,
    ],
  },
];

export default getColumns;
